import { type ApiResponse, getErrorMessage } from '@/shared/api/http/api/response.api'
import AuthService from '@/shared/services/AuthService'
import { useMutation } from '@tanstack/react-query'

export interface ChangePasswordPayload {
  oldPassword: string
  newPassword: string
  /** BE (ChangePasswordRequest) bắt buộc và so khớp với newPassword — thiếu là 400. */
  confirmNewPassword: string
}

export const changePassword = async (payload: ChangePasswordPayload): Promise<ApiResponse> => {
  const res = await AuthService.changePassword(payload)
  if (!res) throw new Error('No response from server')
  if (res.isError) throw new Error(getErrorMessage(res, 'Đổi mật khẩu thất bại'))
  return res
}

export const useChangePassword = () =>
  useMutation({
    mutationFn: changePassword,
  })
